import { render, staticRenderFns } from "./SpacerArea.vue?vue&type=template&id=2bcce97e&scoped=true&"
import script from "./SpacerArea.vue?vue&type=script&lang=ts&"
export * from "./SpacerArea.vue?vue&type=script&lang=ts&"
import style0 from "./SpacerArea.vue?vue&type=style&index=0&id=2bcce97e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcce97e",
  null
  
)

export default component.exports